import { Component, EventEmitter, Output, OnInit, ChangeDetectorRef } from '@angular/core';
import { MessageService } from 'primeng/api';
import { UsersService } from 'src/app/private/services/users.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { SignatureModelComponent } from "../signature-model/signature-model.component";
import { FileUploadModule } from 'primeng/fileupload';
import { UploadService } from 'src/app/private/services/upload.service';
import { ToastModule } from 'primeng/toast';
import { ProfileImageService } from 'src/app/private/services/micro-services/profile-image.service';

@Component({
  selector: 'app-user-profile',
  imports: [SharedModule, SignatureModelComponent, FileUploadModule, ToastModule],
  templateUrl: './user-profile.component.html',
  styleUrl: './user-profile.component.scss'
})
export class UserProfileComponent implements OnInit {

  defaultAvatar = 'https://www.gravatar.com/avatar/?d=mp';

  @Output() closeDialog = new EventEmitter<any>();
  isSubmitted = false;
  user: any = {};
  departmentsList: any;
  roles: any;
  isLoading = false;
  showSignatureModal = false;
  signatures: any[] = [];
  selectedIndex: number | null = null;
  signatureDataToEdit: any;
  editSignatureIndex: number | null = null;
  singatureAction: string = 'Create';


  constructor(private api: UsersService,
    private localStorage: LocalStorageService,
    private messageService: MessageService,
    private uploadService: UploadService,
    private imageService: ProfileImageService,
    private cdr: ChangeDetectorRef
  ) { }

  isInitLoading = true;

  ngOnInit() {
    this.cdr.detectChanges();
    this.getUser();
    this.getAllDepartments();
    this.getAllRoles();
  }

  prefixOptions = [
    { label: 'Select', value: '' },
    { label: 'Mr', value: 'Mr' },
    { label: 'Ms', value: 'Ms' },
    { label: 'Mrs', value: 'Mrs' }
  ];

  genderOptions = [
    { label: 'Select', value: '' },
    { label: 'Male', value: 'Male' },
    { label: 'Female', value: 'Female' },
    { label: 'Other', value: 'Other' }
  ];

  statusOptions = [
    { label: 'Select', value: '' },
    { label: 'Active', value: 'Active' },
    { label: 'Inactive', value: 'Inactive' },
    { label: 'Suspended', value: 'Suspended' }
  ];

  getAllRoles() {
    const payload = {
      organization_id : this.localStorage.getOrganizationId()
    }
    this.api.getAllRoles(payload).subscribe({
      next: (res) => {
        this.roles = res|| [];
        this.cdr.detectChanges();
      },
      error: (e) => {
        this.isLoading = false;
        this.cdr.detectChanges();
      }
    })
  }

  getAllDepartments() {
    const payload = {
      organization_id : this.localStorage.getOrganizationId()
    }
    this.api.getAllDepartment(payload).subscribe({
      next: (res) => {
        this.departmentsList = res || [];
        this.departmentsList = this.departmentsList.map((department: any) => {
          return {
            label: department.name,
            value: Number(department.dept_id)
          }
        }
        );
        this.cdr.detectChanges();
      },
      error: (e) => {
        this.isLoading = false;
        this.cdr.detectChanges();
      }
    })
  }

  getUser() {
    const params = {
      user_id: this.localStorage.getUserId(),
    };

    this.api.getUser(params).subscribe({
      next: (res: any) => {
        this.user = res;
        console.log("user23561", this.user);
        this.signatures = res.user_sign?.map((sign: any) => sign.signature);
        this.selectedIndex = res.user_sign?.findIndex((sign: any) => sign.isActive);
        this.isLoading = false;
        this.isInitLoading = false;
        this.cdr.detectChanges();
      },
      error: (e: any) => {
        console.log(e);
        this.isLoading = false;
        this.isInitLoading = false;
        this.cdr.detectChanges();
      },
    });
  }


  saveUser(isValid: any) {
    this.isSubmitted = true;
    if (isValid) {
      this.isLoading = true;

      const { password, ...userWithoutPassword } = this.user;


      let user_sign: any[] = [];

      this.signatures.forEach((element, index) => {
        user_sign.push({
          signature: element,
          isActive: index === this.selectedIndex ? true : false
        })
      }
      );

      console.log("user_sign", user_sign);

      const payload = {
        ...userWithoutPassword,
        user_sign: user_sign,
      };

      this.api.updateUser(payload).subscribe({
        next: (res: any) => {
          this.getUser();
          this.handleCloseDialog();
          localStorage.setItem('user_sign', JSON.stringify(user_sign));
          // this.toast.success("User Updated Successfully", 'Success')
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'User Updated Successfully' });
          this.isLoading = false;
        },
        error: (e: any) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: (e.error.msg ||
            'Something went wrong, Please try again later'
          ) });
          this.isLoading = false;
        }
      })
    }
  }

  openSignatureModal() {
    this.singatureAction = 'Create';
    this.showSignatureModal = true;
  }

  handleCloseSignatureModel() {
    this.showSignatureModal = false;
  }

  
  handleCloseDialog() {
    this.closeDialog.emit();
  }

  EditSignatureModal(index: number) {
    this.showSignatureModal = true;
    this.signatureDataToEdit = this.signatures[index];
    this.editSignatureIndex = index;
    this.singatureAction = 'Update';
  }

  deleteSignature(index: number) {
    this.signatures.splice(index, 1);
  }

  updateSignaturesData(signature: string) {
    this.signatures.push(signature);
  }

  editSignatureValue(signature: any) {
    if (this.editSignatureIndex !== null) {
      this.signatures[this.editSignatureIndex] = signature;
    }
  }


  async onImageSelect(event: any) {
    const file: File = event.files[0];
    if (!file) return;
    
    this.user.picture = URL.createObjectURL(file); // Preview the image
    try {
      this.messageService.add({ severity: 'info', summary: 'Info', detail: 'Uploading Image...' ,
        key: 'upload'
      });

      const imageUrl = await this.uploadToS3(file); // upload and get S3 URL

      this.imageService.setImage(imageUrl);
      
      
      const {password, ...userWithoutPassword} = this.user;
      const payload = {
        ...userWithoutPassword,
        picture : imageUrl,
      };

    
      this.api.updateUser(payload).subscribe({
        next: (res: any) => {
          this.getUser();          localStorage.setItem('user_sign', JSON.stringify(this.signatures));
          this.localStorage.setProfilePicture(imageUrl)
          this.messageService.clear('upload');
        },
        error: (e: any) => {
          this.messageService.clear('upload');
          this.messageService.add({ severity: 'error', summary: 'Error', detail: (e.error.msg ||
            'Something went wrong, Please try again later'
          ) });
        }
      })

    } catch (err) {
      console.error('Image upload failed:', err);
    }
  }


  async uploadToS3(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      const folder = `education/students/documents`;
      formData.append('file', file);
      formData.append('folders', folder);
      formData.append('bucket', 'global-upload-storage');

      this.uploadService.uploadDocuments(formData).subscribe({
        next: (response: any) => {
          console.log('File uploaded successfully:', response);
          resolve(response.url); // Assuming API returns { url: 's3-url' }
        },
        error: (error) => {
          console.error('Error uploading file:', error);
          reject('');
        },
      });
    });
  }


}
